module.exports = __webpack_public_path__ + "static/media/Eric_Pak.7fcc418a.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/resume/Eric_Pak.pdf
// module id = 73
// module chunks = 0